import { AxiosService } from './axiosService';

export class ProductService extends AxiosService {
    async getProducts(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/products', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getProduct(id) {
        try {
            const { data } = await this.axios.get(`/products/${id}`);
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postProduct(name, price, description, type, occurrence, units, componentId) {
        try {
            const { data } = await this.axios.post('/products', {
                name,
                price,
                description,
                type,
                occurrence,
                units,
                componentId: componentId ? componentId : null
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async editProduct(id, name, price, description, type, occurrence, units, componentId) {
        try {
            const { data } = await this.axios.put(`/products`, {
                id,
                name,
                price,
                description,
                type,
                occurrence,
                units,
                componentId: componentId ? componentId : null
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteProduct(id) {
        try {
            const { data } = await this.axios.delete(`/products`, {
                data: {
                    id
                },
            });
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async toggleProduct(distributorId, productId, enabled) {
        try {
            const { data } = await this.axios.put(`/products/toggle`, {
                distributorId,
                productId,
                enabled
            });
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const productService = new ProductService();
